// Pick market from the visitor's domain, swap prices (Market\Price), texts (Market\Text) and shop links.
// The market can be forced for testing with ?rb_host=kaidekauppa.fi (kept for the session).

const markets = (window.webienSite && window.webienSite.markets) || {};
const aliases = (window.webienSite && window.webienSite.marketAliases) || {};
const defaultHost = 'rackesbutiken.se';

// Market::ALIASES, ex. rackesbutiken.se.haus.se/en (host + Weglot language segment) or a host only
function aliasHost(host, hostAliases = aliases) {
    const segment = window.location.pathname.split('/')[1] || '';

    return hostAliases[host + '/' + segment] || hostAliases[host] || host;
}

function currentHost(availableMarkets = markets, hostAliases = aliases) {
    let host = aliasHost(window.location.hostname.replace(/^www\./, ''), hostAliases);

    try {
        const forced = new URLSearchParams(window.location.search).get('rb_host');
        if (forced) {
            sessionStorage.setItem('rb_host', forced);
        }
        host = sessionStorage.getItem('rb_host') || host;
    } catch (e) {
        // sessionStorage unavailable, use the real host
    }

    return availableMarkets[host] ? host : defaultHost;
}

const host = currentHost();

window.rbMarket = Object.assign({ host: host }, markets[host] || { locale: 'sv-SE', country_code: 'SE', currency: 'SEK', vat_rate: 0.25 });
// A translated document is available independently of whether market prices are active.
window.rbDocumentHost = currentHost(
    (window.webienSite && window.webienSite.documentMarkets) || markets,
    (window.webienSite && window.webienSite.documentMarketAliases) || aliases
);

const rates = (window.webienSite && window.webienSite.currencyRates) || { SEK: 1 };

// SEK amount excl. VAT to the market's currency excl. VAT, null if the rate is missing
window.rbConvertFromSek = function (amount) {
    const rate = rates[window.rbMarket.currency];
    return rate ? amount * rate : null;
};

// Whole units in the market's locale and currency, ex. 13 381 kr, 1.234 €
window.rbFormatPrice = function (amount) {
    return new Intl.NumberFormat(window.rbMarket.locale, {
        style: 'currency',
        currency: window.rbMarket.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};

// Each market has its own shop, ex. shop.kaidekauppa.fi
window.rbShopUrl = function (path) {
    return 'https://shop.' + window.rbMarket.host + (path || '');
};

// Weglot language segment of the current URL on alias hosts, ex. '/da' on rackesbutiken.se.haus.se/da/, else ''
function languagePrefix() {
    const currentHostname = window.location.hostname.replace(/^www\./, '');
    const segment = window.location.pathname.split('/')[1] || '';

    return segment && aliases[currentHostname + '/' + segment] ? '/' + segment : '';
}

// Keep internal links relative to the visitor's domain, including any language path.
// Ex. https://rackesbutiken.se/produkter/forma/ => /produkter/forma/
// or /da/produkter/forma/ on an alias host. Other domains are left as is.
window.rbLocalUrl = function (url) {
    let parsed;
    try {
        parsed = new URL(url, window.location.href);
    } catch (e) {
        return url;
    }

    const linkHost = parsed.hostname.replace(/^www\./, '');
    const currentHostname = window.location.hostname.replace(/^www\./, '');
    if (linkHost !== defaultHost && linkHost !== currentHostname) {
        return url;
    }

    const prefix = languagePrefix();
    let path = parsed.pathname;
    if (prefix && path !== prefix && path.indexOf(prefix + '/') !== 0) {
        path = prefix + path;
    }

    return path + parsed.search + parsed.hash;
};

function swapShopLinks(root) {
    if (window.rbMarket.host === defaultHost || !root.querySelectorAll) {
        return;
    }

    root.querySelectorAll('a[href^="https://shop.' + defaultHost + '"]').forEach((a) => {
        a.href = a.href.replace('https://shop.' + defaultHost, 'https://shop.' + window.rbMarket.host);
    });
}

function swapPrices(root) {
    const elements = root.querySelectorAll ? root.querySelectorAll('.rb-price[data-prices]') : [];

    elements.forEach((el) => {
        let prices;
        try {
            prices = JSON.parse(el.dataset.prices);
        } catch (e) {
            return;
        }

        const value = el.querySelector('.rb-price-value') || el;
        const price = prices[window.rbMarket.locale];
        if (price && value.textContent !== price) {
            value.textContent = price;
        }

        // Price decided, hide the loader (keeps the default price if the market has none)
        el.classList.remove('is-loading');
    });
}

// Elements with the class rb-if-campaign / rb-if-no-campaign (ex. two Elementor headings with the price tag)
// are shown if the price inside has / has not a campaign in the visitor's market (data-campaigns from Market\Price).
// Elements without a price (ex. a campaign badge) use the closest price around them.
const campaignSelector = '.rb-if-campaign, .rb-if-no-campaign';

function toggleCampaigns(root) {
    const elements = root.querySelectorAll ? Array.from(root.querySelectorAll(campaignSelector)) : [];

    // The price may be inserted inside an already rendered element
    if (root.closest) {
        const parent = root.closest(campaignSelector);
        if (parent) {
            elements.push(parent);
        }
    }

    elements.forEach((el) => {
        // Price inside the element, else the closest one around it (ex. a campaign badge next to the price)
        let price = el.querySelector('.rb-price[data-campaigns]');
        for (let parent = el.parentElement; !price && parent; parent = parent.parentElement) {
            price = parent.querySelector('.rb-price[data-campaigns]');
        }

        let campaigns = [];

        if (price) {
            try {
                campaigns = JSON.parse(price.dataset.campaigns);
            } catch (e) {
                campaigns = [];
            }
        }

        const isCampaign = campaigns.indexOf(window.rbMarket.locale) !== -1;
        const show = el.classList.contains('rb-if-campaign') ? isCampaign : !isCampaign;

        el.classList.toggle('rb-campaign-match', show);
    });
}

// API texts per market (ex. product description), may contain HTML like <br>
function swapTexts(root) {
    const elements = root.querySelectorAll ? root.querySelectorAll('.rb-text[data-texts]') : [];

    elements.forEach((el) => {
        let texts;
        try {
            texts = JSON.parse(el.dataset.texts);
        } catch (e) {
            return;
        }

        const text = texts[window.rbMarket.locale];
        if (text && el.dataset.rbLocale !== window.rbMarket.locale) {
            el.innerHTML = text;
            el.dataset.rbLocale = window.rbMarket.locale;
        }
    });
}

// Documents are selected by market even when Weglot serves cached Swedish HTML.
function swapDocuments(root) {
    const elements = root.querySelectorAll ? Array.from(root.querySelectorAll('[data-rb-documents]')) : [];
    if (root.matches && root.matches('[data-rb-documents]')) {
        elements.push(root);
    }

    elements.forEach((el) => {
        let documents;
        try {
            documents = JSON.parse(el.dataset.rbDocuments);
        } catch (e) {
            return;
        }
        const document = documents[window.rbDocumentHost];
        el.hidden = !document;
        if (!document) {
            return;
        }
        const link = el.querySelector('a');
        const label = el.querySelector('[data-rb-document-label]');
        if (link && link.getAttribute('href') !== document.file) {
            link.setAttribute('href', document.file);
        }
        if (label && label.textContent !== document.label) {
            label.textContent = document.label;
        }
    });

    // Hide empty categories in both the product accordion and reactive archive.
    document.querySelectorAll('.downloads .item, .webien-reactive-list-app .list-items, .rb-downloads-app .list-items').forEach((group) => {
        const documents = Array.from(group.querySelectorAll('[data-rb-documents]'));
        if (documents.length) {
            group.hidden = documents.every((el) => el.hidden);
        }
    });
}

function init() {
    swapPrices(document);
    swapTexts(document);
    swapShopLinks(document);
    toggleCampaigns(document);
    swapDocuments(document);

    // Prices rendered later by Vue (ex. product lists) are swapped when inserted
    new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) {
                    return;
                }
                const root = node.matches('.rb-price[data-prices], .rb-text[data-texts], a') ? node.parentNode : node;
                swapPrices(root);
                swapTexts(root);
                swapShopLinks(root);
                toggleCampaigns(root);
                swapDocuments(root);
            });
        });
    }).observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
